"use strict";
import "polyfill";
import controllerF from 'controller/home';
import view from 'view/home';

let home = document.getElementById('home');

controllerF(
    home,
    view
).exec();